import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import TitleListSortingSwitchPopover from '@/components/list/sorting/TitleListSortingSwitchPopover.vue';

import { CollectionType } from '@/enums/collection-type';
import { TitleOrder } from '@/enums/title-order';

import { defaultSortingItemSelectedKeys, sortingItemsByCollectionType } from '@/helpers/list-sorting-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { isProWebCountry } from '@/helpers/pro-web-helper';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';
import { getSelectedTab } from '@/components/popular/provider-module/helper';
import { useUserStore, useFilterStore, useLanguageStore, useRoutingStore } from '@/helpers/composables/useStores';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleListSortingSwitcherSeo',
  props: {
    collectionType: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
};



const { filters } = useFilterStore();
const { webLocale } = useLanguageStore();
const { queryParams, activeRoute } = useRoutingStore();
const { showFreemium } = useUserStore();

const defaultSortingItemKey = computed(() => defaultSortingItemSelectedKeys[props.collectionType]);

const supportsProWeb = computed(() => isProWebCountry(webLocale.value));

const sortingItems = computed(() => {
	if (!supportsProWeb.value && !showFreemium.value) {
		return sortingItemsByCollectionType[props.collectionType].filter(item => !item.premium);
	}
	return sortingItemsByCollectionType[props.collectionType];
});

const sortByFilter = computed<TitleOrder>(() => {
	if (queryParams.value.sort_by) {
		const hasSortingItem = sortingItems.value.some(item => item.key === queryParams.value.sort_by);
		return hasSortingItem ? (queryParams.value.sort_by as TitleOrder) : defaultSortingItemKey.value;
	}
	return (filters.value.sort_by as TitleOrder) || defaultSortingItemKey.value;
});

const selectedItem = computed(() => sortingItems.value.find(item => item.key === sortByFilter.value));

const openSelection = (event: Event) => {
	const routeName: string = activeRoute.value?.name;
	const selectedTab = getSelectedTab(routeName);

	TrackingHelper.trackEvent('userinteraction', {
		action: 'sorting_dropdown_clicked',
		property: selectedTab,
	});

	PopoverHelper.create({
		popoverProps: {
			cssClass: 'static-pages-popover',
			boundingElement: event.currentTarget,
		},
		component: TitleListSortingSwitchPopover,
	});
};

return { __sfc: true,props, filters, webLocale, queryParams, activeRoute, showFreemium, defaultSortingItemKey, supportsProWeb, sortingItems, sortByFilter, selectedItem, openSelection, faChevronDown }
}

})